import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";
import { API_URL } from "../../lib/utils";

export const FiscalReadinessBanner = () => {
  const [r, setR] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/fiscal/readiness`, { withCredentials: true }).then((res) => setR(res.data)).catch(() => setR(null));
  }, []);

  if (!r) return null;
  const overdue = r.saft_overdue || [];
  if (r.ready && !overdue.length) return null;

  const issues = [];
  if (overdue.length) issues.push({ key: "saft", text: `SAF-T em atraso na AGT: ${overdue.map((m) => m.label).join(", ")}`, to: "/saft", cta: "Fiscal · SAF-T", detail: `prazo${overdue.length > 1 ? "s" : ""} ${overdue.map((m) => m.deadline.split("-").reverse().join("/")).join(", ")} ultrapassado${overdue.length > 1 ? "s" : ""}` });
  if (!r.nif_ok) issues.push({ key: "nif", text: "NIF da empresa em falta ou inválido (10 dígitos)", to: "/settings", cta: "Definições" });
  if (!r.address_ok) issues.push({ key: "address", text: "Morada da empresa por preencher", to: "/settings", cta: "Definições" });
  if (r.exemption_missing.length) {
    const n = r.exemption_missing.length;
    issues.push({ key: "exemption", text: `${n} artigo${n > 1 ? "s" : ""} isento${n > 1 ? "s" : ""} de IVA sem motivo de isenção (M00…)`, to: "/products", cta: "Produtos", detail: r.exemption_missing.slice(0, 3).map((p) => p.name).join(", ") + (n > 3 ? "…" : "") });
  }

  return (
    <div className={`rounded-xl border p-4 flex gap-3 ${overdue.length ? "border-red-300 bg-red-50" : "border-amber-300 bg-amber-50"}`} data-testid="fiscal-readiness-banner">
      <AlertTriangle className={`w-5 h-5 shrink-0 mt-0.5 ${overdue.length ? "text-red-600" : "text-amber-600"}`} />
      <div className="flex-1 min-w-0">
        <p className={`font-semibold ${overdue.length ? "text-red-900" : "text-amber-900"}`}>{overdue.length ? "Obrigações fiscais em atraso — entregue o SAF-T à AGT" : "Dados fiscais incompletos — as facturas e o SAF-T podem ser recusados pela AGT"}</p>
        <ul className="mt-2 space-y-1.5">
          {issues.map((i) => (
            <li key={i.key} className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-sm ${overdue.length ? "text-red-900" : "text-amber-900"}`} data-testid={`fiscal-readiness-issue-${i.key}`}>
              <span>• {i.text}{i.detail ? <span className={overdue.length ? "text-red-700" : "text-amber-700"}> — {i.detail}</span> : null}</span>
              <Link to={i.to} className={`inline-flex items-center gap-1 font-medium underline underline-offset-2 ${overdue.length ? "text-red-800 hover:text-red-950" : "text-amber-800 hover:text-amber-950"}`} data-testid={`fiscal-readiness-link-${i.key}`}>
                {i.cta} <ArrowRight className="w-3.5 h-3.5" />
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
